var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-loadmore",class:{'weui-loadmore_line':_vm.loadingState==2}},[(_vm.loadingState==1)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"weui-loadmore__tips",domProps:{"innerHTML":_vm._s(_vm.tipsText)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000eb22e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadmore/loadmore.vue
// module id = 299
// module chunks = 0